import { api } from '@/lib/http.js'

/**
 * A catalogue text translated by the company's AI (D-355; never a cloud) while the person waits:
 * the words, or a formatted text (its build kept). Not answered in time: asked about again every
 * few seconds, for a few minutes.
 */
export async function aiTranslate(value, to, from = null) {
  let answer = (await api('/catalog/translate', { method: 'POST', body: { value, to, from }, timeoutMs: 90000 })).data
  const until = Date.now() + 180000
  while (answer.state === 'queued' && Date.now() < until) {
    await new Promise((r) => setTimeout(r, 3000))
    answer = (await api(`/catalog/translate/${answer.job}`, { timeoutMs: 30000 })).data
  }
  if (answer.state !== 'done') throw new Error('timeout')
  return answer.value
}

/** Whether the company's AI is on (Settings → AI). */
export const aiOn = (meta) => !!meta.data?.settings?.ai?.enabled
